export default __webpack_public_path__ + "google-qr.png";